import { Component, Input } from '@angular/core';

@Component({
  selector: 'my-bill-nothing-to-pay-card',
  templateUrl: './my-bill-nothing-to-pay-card.component.html',
  standalone: false,
})
export class MyBillNothingToPayCardComponent {
  @Input() hasInstalmentPlan: Boolean;
}
